import EmpNotesPage from "../Employee/EmpNotesPage";

function NotesSection() {
  return <EmpNotesPage />;
}

export default NotesSection;
